export default __webpack_public_path__ + "static/media/ultrasonic.44ea447d.svg";